import Axios from "../api/Axios";
const BASE_URL = "RSECutomer/";



export const Endpoint = {
    GetRSECustList: "GetRSECustList",
    GetGEOGInfo: "GetGEOGInfo",
    ApproveReject: "ApproveReject",
    UpdateActiveStatus: "UpdateActiveStatus"
};

export const createAPIEndpoint = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data)
    };
};